@if (loadingPage) {
  <app-loading></app-loading>
}
@if (globals.gminval !='') {
  <div>
    <app-screen-message [errors]="screenErrors" [messages]="screenMessages"></app-screen-message>
    <div class="searchContainer">
      <app-expandable  [expandable]="false" [title]="globals.i18n.title.contactus">
        @if ( globals.systemerror !== true && mailsuccess !== true) {
          <div >
            <!--      <form class="searchForm">-->
            <div class="container">
              <br>
                <div class="row centeredFlex">
                  <app-textbox-control [labelText]="globals?.i18n.field.label.gmin" [(value)]="searchModel.gmin"
                    [isButtonDisplayed]="false"
                    [editable] = "false"
                    [validator]="searchValidator.addProperty('gmin')"
                  ></app-textbox-control>
                  <app-textbox-control [labelText]="globals?.i18n.field.label.email" [(value)]="searchModel.emailAddress"
                    [isButtonDisplayed]="false"
                    [validator]="searchValidator.addProperty('email')"
                  ></app-textbox-control>
                </div>
                <div class="row centeredFlex">
                  <ul>
                    <li class="special2">
                      If you are contacting us to inquire on the status of an application or payment, please check the <span class="link" routerLink="/mylayoffbenef/cisaGetHistory">“Processed and Pending History”</span> including clicking on <span class="link" (click)="applicationLink()">“Check on Application Errors”</span>.
                    </li>
                    <br>
                      <li class="special2">
                        If you are from an AutoSUB location and don’t see an application, be aware that these applications are not received from the state until at least one week after the Unemployment Payment is issued and can take up to three weeks.
                      </li>
                      <br>
                        <li class="special2">
                          AutoSUB applications become available on the following days:
                        </li>
                        <br>
                          <li class="special2">
                            MI - Applications are available to view beginning on Tuesdays
                          </li>
                          <br>
                            <li class="special2">
                              MO - Applications are available to view beginning on Thursdays
                            </li>
                            <br>
                              <li class="special2">
                                NY - Applications are available to view beginning on Tuesdays
                              </li>
                              <br>
                                <li class="special2">
                                  TX - Applications come in right before Thursday night processing.   You will not see them pending.
                                </li>
                                <br>
                                  <li class="special2">
                                    All payments become visible starting on Fridays when they are transmitted to payroll for payout the following Friday.
                                  </li>
                                </ul>
                              </div>
                              <div class="row centeredFlex">
                                <app-screen-message [errors]="errorMessages"></app-screen-message>
                              </div>
                              <div class="row" >
                                <app-textarea
                                  [label] = "globals?.i18n.field.label.comments"
                                  [(value)]="searchModel.comment"
                                  [bigInput]="true"
                                  [mandatory]="true"
                                  >
                                </app-textarea>
                              </div>
                              <div class="rowContainer centeredFlex">
                                <app-button class="margin" type="primary" value="{{globals.i18n.application.button.submit}}"
                                  (click)="emailSubmit()" (keyup.enter)="emailSubmit()"
                                  [disabled]="loadingSearch"
                                ></app-button>
                                <app-button class="margin" type="secondary" value="{{globals.i18n.application.button.reset}}"
                                  (click)="clearSearch()"
                                ></app-button>
                              </div>
                            </div>
                            <br>
                              <br>
                              <!--      </form>-->
                            </div>
                          }
                          @if ( globals.systemerror === true) {
                            <div >
                              <app-system-error></app-system-error>
                            </div>
                          }
                          @if ( this.mailsuccess === true) {
                            <div >
                              <div class="container">
                                <div class="row">
                                  <h4>Your input has successfully been sent. Thank you!</h4>
                                </div>
                                <div class="row">
                                  <app-button class="margin" type="primary" value="Return to Home"
                                    (click)="returnhome()" (keyup.enter)="returnhome()"
                                  ></app-button>
                                  <p>Please use the button to return to the home page.</p>
                                </div>
                              </div>
                            </div>
                          }
                        </app-expandable>
                      </div>
                      @if (loadingSearch) {
                        <app-loading></app-loading>
                      }
                    </div>
                  }
